import React from "react";
import "./RmaProgressTracker.scss";
import IRMA from "../../../models/IRMA";
import OwLabel from "../OwLabel/OwLabel";
import UIService from "../../../services/UIService";
import RmaStatusEnum from "../../../models/RmaStatusEnum";

type Props = {
    rma: IRMA;
};

interface RmaStep {
    status_id: number;
    step_no: number;
    name: string;
}

export const RmaProgressTracker = (props: Props) => {
    const getChevron = (isSelected?: boolean): any => {
        return (
            <div className={"line " + (isSelected ? "selected" : "")}>
                <i className={"fas fa-chevron-double-right"} />
            </div>
        );
    };

    const getStepMarker = (title: string, isSelected?: boolean, showTitleOnMobile?: boolean): any => {
        return (
            <div id={`progress-${title}`} className={"d-flex flex-column " + (isSelected ? "selected" : "")}>
                <div className={"d-flex justify-content-center mb-2"}>
                    <i className={isSelected ? "fas fa-circle-check" : "fas fa-circle"} />
                </div>
                <div className={"font-small text-muted text-truncate-mobile step-title " + (showTitleOnMobile ? "" : "")}>
                    <OwLabel noBottomMargin={true} title={title} />
                </div>
            </div>
        );
    };

    // Define RMA workflow steps
    const rmaSteps: RmaStep[] = [
        {
            status_id: RmaStatusEnum.DRAFT,
            step_no: 1,
            name: "draft",
        },
        {
            status_id: RmaStatusEnum.AUTHORIZED,
            step_no: 2,
            name: "authorized",
        },
        {
            status_id: RmaStatusEnum.RECEIVED,
            step_no: 3,
            name: "received",
        },
        {
            status_id: RmaStatusEnum.PROCESSED,
            step_no: 4,
            name: "processed",
        },
    ];

    const currentStatus = props.rma.rma_status_id;
    let currentStepNo = 0;

    // If cancelled, don't highlight any steps
    if (currentStatus === RmaStatusEnum.CANCELLED) {
        currentStepNo = 0;
    } else {
        for (const step of rmaSteps) {
            if (step.status_id === currentStatus) {
                currentStepNo = step.step_no;
                break;
            }
        }
    }

    return (
        <div className="RmaProgressTracker">
            <div
                className={
                    "OrderProgressTracker d-inline-flex align-items-center justify-content-center rounded-5 d-inline-flex p-2 " +
                    (UIService.isMainViewLight() ? "bg-white" : "bg-dark")
                }>
                {rmaSteps.map((step, index) => {
                    const isSelected = step.step_no <= currentStepNo;

                    if (index > 0) {
                        return (
                            <React.Fragment key={index}>
                                {getChevron(isSelected)}
                                {getStepMarker(step.name, isSelected, true)}
                            </React.Fragment>
                        );
                    } else {
                        return <React.Fragment key={index}>{getStepMarker(step.name, isSelected, true)}</React.Fragment>;
                    }
                })}
            </div>
        </div>
    );
};
